/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { ChevronDown, ChevronRight } from '@elliemae/ds-icons';
import { styled } from '@elliemae/ds-system';

const ChevronWrap = styled.div`
  margin-top: ${(props) => (props.align === 'top' ? '18px' : '0')};
  align-self: ${(props) => (props.align === 'top' ? 'flex-start' : 'center')};
  margin-left: ${(props) => props.theme.space.xs};
`;

export const ExpandChevron = ({ isExpanded, onClick, align }) => {
  const Chevron = isExpanded ? ChevronDown : ChevronRight;
  return (
    <ChevronWrap data-testid="ds-card-expand-chevron" align={align}>
      <Chevron size="s" color={['brand-primary', 800]} onClick={onClick} />
    </ChevronWrap>
  );
};
